import { render, staticRenderFns } from "./MetaTerms.vue?vue&type=template&id=59d0d990&"
import script from "./MetaTerms.vue?vue&type=script&lang=js&"
export * from "./MetaTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports